import CupTrack from "./CupTrack"
import './Cup.css'

export default function Cup(props) {
  return <div className="cup">
    {
      props.tracks?.map((track, index) => {
        return <CupTrack
          start={track?.start}
          end={track?.end}
          key={index}
        />
      })
    }
  </div>
}